module.exports = __webpack_public_path__ + "static/media/plus-primary.66b98e4c.svg";